import React, { useRef } from "react";
import {
  Grid,
  Button,
  Input,
  TextField,
  FormControl,
  InputAdornment,
  MenuItem,
} from "@material-ui/core";
import NewEditor from "./InputAreaComponents/NewEditor";
import styled from "styled-components";
import SelectMultiLevel from "app/common/components/input/Menu/SelectMultiLevel";

export const InputArea = ({
  from_emails,
  editorState,
  setEditorState,
  variables,
  setChange,
  setDrafts,
  selectedNodesCount,
  mailData,
  setMailData,
  columnsForMultiSelect,
  showAlert,
}) => {
  const handleChange = (e) => {
    if (e.target.value == "connect_new") {
      setMailData({ ...mailData, selectedFromEmail: null, openManageAccountModal: true });
      setDrafts([]);
    } else {
      setMailData({
        ...mailData,
        selectedFromEmail: e.target.value,
        draftId: null,
        selectedTemplate: null,
        showAttachmentAlert: false,
      });
    }
  };

  const clickRef = useRef(null);
  return (
    <Grid container direction="column" className="calc" style={{ padding: "5px 20px" }}>
      <Grid container alignItems="center">
        <StyledGrid1 item>
          <TextField
            // onClick={() => setChange((prev) => !prev)}
            select
            size="small"
            fullWidth
            variant="standard"
            value={mailData.selectedFromEmail}
            InputProps={{
              startAdornment: <InputAdornment position="start">From</InputAdornment>,
            }}
            helperText="Connect your email account."
            onChange={handleChange}
          >
            {from_emails.map(
              (el) =>
                el.status === "ACTIVE" && (
                  <MenuItem key={el.id} value={el.id}>
                    {el.email}
                  </MenuItem>
                )
            )}
            <MenuItem value="connect_new">Connect a new email account...</MenuItem>
          </TextField>
        </StyledGrid1>
      </Grid>
      <Grid container>
        <StyledGrid item>
          {columnsForMultiSelect.length > 0 && (
            <div style={{ height: "0px", overflow: "hidden" }}>
              <SelectMultiLevel
                Buttonref={clickRef}
                id="to_emails"
                filterFunction={(e) => e.column_type_id == "10" || e.column_type_id == "14"}
                values={columnsForMultiSelect}
                valueKey="alias_path"
                displayKey="name"
                value={mailData.selectedToEmail ? mailData.selectedToEmail : ""}
                label="To email"
                fullWidth
                onChange={(val) => {
                  if (val.column_type_id == "14") {
                    setMailData({ ...mailData, selectedToEmail: val.alias_path });
                  }
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                forMail={true}
              />
            </div>
          )}
          <TextField
            onClick={() => {
              try {
                clickRef.current.click();
              } catch (error) {
                // console.log(error);
              }
            }}
            disabled
            fullWidth
            variant="standard"
            placeholder={
              columnsForMultiSelect.length <= 0 ? "No email type field found in sheet" : ""
            }
            size="small"
            InputProps={{
              startAdornment: <InputAdornment position="start">To</InputAdornment>,
              endAdornment: (
                <InputAdornment position="start" style={{ marginRight: "20px" }}>
                  {`(${selectedNodesCount})`}
                </InputAdornment>
              ),
            }}
            helperText="Select an email field from the sheet"
            value={mailData.selectedToEmail}
          />
        </StyledGrid>
        <Grid item>
          <Button
            onClick={() => {
              setMailData({ ...mailData, showCcField: !mailData.showCcField, cc: "" });
            }}
          >
            {!mailData.showCcField ? "Add Cc" : "Remove Cc"}
          </Button>
        </Grid>
      </Grid>
      {mailData.showCcField && (
        <StyledGrid container alignItems="center">
          <Grid style={{ flex: "1" }} item>
            <FormControl fullWidth>
              <Input
                value={mailData.cc}
                fullWidth
                onChange={(e) => setMailData({ ...mailData, cc: e.target.value })}
                startAdornment={<InputAdornment position="start">Cc</InputAdornment>}
              />
            </FormControl>
          </Grid>
        </StyledGrid>
      )}
      <StyledGrid container alignItems="center">
        <Grid item style={{ flex: "1" }}>
          <FormControl fullWidth>
            <Input
              disabled={mailData.draftId ? true : false}
              value={mailData.subject}
              onChange={(e) => setMailData({ ...mailData, subject: e.target.value })}
              startAdornment={<InputAdornment position="start">Subject</InputAdornment>}
            />
            {mailData.draftId && (
              <div style={{ color: "red", fontSize: "10px" }}>
                Cannot edit subject or body when draft is selected.
              </div>
            )}
          </FormControl>
        </Grid>
      </StyledGrid>
      {mailData.saveTemplate && (
        <StyledGrid container alignItems="center">
          <Grid style={{ flex: "1" }} item>
            <FormControl fullWidth>
              <Input
                value={mailData.saveTemplateName}
                fullWidth
                onChange={(e) => setMailData({ ...mailData, saveTemplateName: e.target.value })}
                startAdornment={<InputAdornment position="start">Template Name</InputAdornment>}
              />
            </FormControl>
          </Grid>
        </StyledGrid>
      )}
      <Grid item>
        <NewEditor
          disabled={mailData.draftId ? true : false}
          editorState={editorState}
          setEditorState={setEditorState}
          variables={variables}
          showAlert={showAlert}
        />
      </Grid>
    </Grid>
  );
};

export default InputArea;

const StyledGrid = styled(Grid)`
  && {
    flex: 1;
    margin-bottom: 10px;
  }
`;
const StyledGrid1 = styled(Grid)`
  && {
    flex: 1;
    margin: 10px 0;
  }
`;
